'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getDeviceInfo() {
  var nav = typeof navigator === 'undefined' ? null : navigator;
  var conn = nav && nav.connection ? nav.connection : null;
  return {
    // eslint-disable-next-line no-restricted-globals
    url: location ? location.href : null,
    referrer: document ? document.referrer : null,
    userAgent: nav ? nav.userAgent : null,
    memory: nav ? nav.deviceMemory : undefined,
    cpus: nav ? nav.hardwareConcurrency : undefined,
    connection: conn ? {
      effectiveType: conn.effectiveType,
      rtt: conn.rtt,
      downlink: conn.downlink
    } : undefined
  };
}
var labelMap = new Map();
labelMap.set('CLS', 'Cumulative Layout Shift');
labelMap.set('FID', 'First Input Delay');
labelMap.set('FCP', 'First Contentful Paint');
labelMap.set('lCP', 'Largest Contentful Paint');
labelMap.set('TTFB', 'Time to First Byte');
var formatWebVitalsPayload = function formatWebVitalsPayload(_ref) {
  var metric = _ref.metric,
    appName = _ref.appName,
    mfeAppName = _ref.mfeAppName,
    location = _ref.location,
    user = _ref.user;
  return {
    userId: user.id,
    app: appName,
    // eslint-disable-next-line no-restricted-globals
    location: location.pathname,
    mfeAppName: mfeAppName,
    metricCategory: metric.name,
    metricName: labelMap.get(metric.name),
    value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    id: metric.id,
    rating: metric.rating ? metric.rating : 'not rated',
    region: Intl.DateTimeFormat().resolvedOptions().timeZone,
    deviceInfo: getDeviceInfo(),
    fullMetricData: metric,
    userInfo: user
  };
};

exports.formatWebVitalsPayload = formatWebVitalsPayload;
exports.getDeviceInfo = getDeviceInfo;
